module.exports = __webpack_public_path__ + "static/media/builtinv2-osveshenie.f4856a78.png";